import React from 'react';

import Utilities from '../utility/Utilities.jsx';

function Container(props) {
    const config = props.config || {};
    let clickHandler = props.onClick;
    let style = props.style || {};
    if (config.config && config.config.Style) {
        clickHandler = (e) => {
            if (e) {
                e.stopPropagation();
            }
            if (props.onClick) {
                props.onClick(config.id);
            }
        };
        style = Utilities.Config.getStyle(config.config.Style, style);
    }
    const bodyProps = props.bodyProps || {};
    return (
        <table
            border="0"
            cellPadding={props.cellPadding || "0"}
            cellSpacing={props.cellSpacing || "0"}
            className={props.className}
            data-block-type={config.type && config.type.value}
            data-type={props.dataType}
            draggable={props.builder == true}
            id={config.Id || config.id}
            style={style}
            width="100%"
            onClick={clickHandler}
            onDragEnter={props.onDragEnter}
            onDragOver={props.onDragOver}
            onDragStart={props.onDragStart}>
            <tbody {...bodyProps}>
                {props.children}
            </tbody>
        </table>
    );
}

export default Container;